import React from 'react';

const PrivacyPolicy = () => {
    return (
        <div className="max-w-4xl mt-24 mx-auto py-10 px-4 text-gray-800">
            <h1 className="text-3xl font-semibold text-black mb-4">Privacy Policy</h1>
            <p className="text-sm text-gray-500">Last Updated: 11 November 2024</p>

            <section className="mt-6 space-y-4">
                <p className="leading-relaxed">
                    XReality Education Limited (“we,” “our,” or “us”) is committed to protecting the privacy of all users,
                    including children and parents, who interact with our platform. This Privacy Policy outlines how we
                    collect, use, disclose, and protect personal information in accordance with Canadian privacy laws,
                    including the Personal Information Protection and Electronic Documents Act (PIPEDA), and addresses our
                    specific protections for children’s privacy.
                </p>
            </section>

            <div className="border-b border-gray-200 my-6"></div>

            <h2 className="text-xl font-bold text-black mt-8">1. Information We Collect</h2>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li><strong>Email Addresses:</strong> We collect email addresses provided during account registration, newsletter subscription, or customer support interactions.</li>
                <li><strong>Personal Information:</strong> This may include name, age, educational level, and preferences, provided voluntarily to personalize the learning experience.</li>
                <li><strong>Information from Children:</strong> If children under the age of 18 access our platform, we obtain verifiable consent from a parent or guardian before collecting any personal information.</li>
            </ul>

            <h2 className="text-xl font-bold text-black mt-8">2. How We Use Personal Information</h2>
            <p className='my-2'>We collect and use personal information for the following purposes:</p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>To Provide and Improve Services:</strong> We use email addresses and other information to deliver course content, personalized recommendations, and maintain account information.</li>
                <li>- <strong>To Communicate:</strong> We send updates, support responses, and newsletters to users who have opted in. Users may unsubscribe from promotional emails at any time.</li>
                <li>- <strong>To Enhance User Experience:</strong> We use personal information to understand user preferences, improve content, and provide a better educational experience.</li>
                <li>- <strong>For Security:</strong> We use data to detect and prevent fraud or abuse and to maintain platform security.</li>
            </ul>
            <h2 className="text-xl font-bold text-black mt-8">  3. Consent and Age Requirements</h2>
            <p className='my-2'>We comply with Canadian & International laws regarding consent and parental involvement, especially for users under the age of 18.</p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>Children’s Consent:</strong> For users under 18, verifiable parental consent is required before collecting any personal information.</li>
                <li>- <strong>Withdrawing Consent:</strong>  Users or parents may withdraw their consent to collect or use their personal information at any time by contacting us at <a href="mailto:info@xrealityedu.com" className="text-primary hover:underline">info@xrealityedu.com</a>.

                </li>


            </ul>
            <h2 className="text-xl font-bold text-black mt-8">  4. Disclosure of Information</h2>
            <p className='my-2'>We do not sell or share any personal information with third parties, except in the following situations:

            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>Service Providers:</strong> We may share data with third-party vendors who assist with services such as email delivery and data processing. All service providers are required to uphold privacy standards.</li>
                <li>- <strong>Legal Requirements:</strong>   We may disclose information if required by law or to protect the rights, safety, and security of our users, employees, or the public.

                </li>
                <li>- <strong> Business Transfers:</strong>   In the event of a merger, acquisition, or sale, user information may be transferred, and users will be notified of any such changes.
                </li>

            </ul>



            <h2 className="text-xl font-bold text-black mt-8">   5. Children’s Privacy Protection:</h2>
            <p className='my-2'>We take children’s privacy seriously and have special safeguards to protect users under 18:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>Limited Data Collection:</strong>We only collect the minimum necessary information for educational purposes.</li>
                <li>- <strong>Parental Access and Control: </strong>  Parents or guardians can access, update, or delete their child’s personal information by contacting us at <a href="mailto:info@xrealityedu.com" className="text-primary hover:underline">info@xrealityedu.com</a>.


                </li>
                <li>- <strong>No Marketing to Children:</strong>  We do not knowingly send promotional emails to users under 18.
                </li>

            </ul>



            <h2 className="text-xl font-bold text-black mt-8">   6. Security Measures:</h2>
            <p className='my-2'>We implement strong security measures to protect personal information:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>Data Encryption:</strong>All personal information is encrypted during transmission and storage.</li>
                <li>- <strong>Access Controls: </strong>  Only authorized personnel have access to user data.


                </li>
                <li>- <strong>Regular Audits:</strong>  We conduct regular security audits to identify and address potential vulnerabilities.
                </li>

            </ul>

            <h2 className="text-xl font-bold text-black mt-8">7. Access and Correction of Personal Information:</h2>
            <p className='my-2'>Users have the right to access and correct their personal information:
            </p>
            <ul className="mt-4 space-y-2 text-gray-700">
                <li>- <strong>Access Requests:</strong>To access personal information, contact us at [<a href="mailto:info@xrealityedu.com" className="text-primary hover:underline">info@xrealityedu.com</a>.]. We will respond within 30 days.
                </li>
                <li>- <strong>Correction Requests:</strong>  Users may request to correct any inaccurate information, and we will update our records promptly.


                </li>
              

            </ul>

            <h2 className="text-xl font-bold text-black mt-8">8. Retention of Personal Information:</h2>
            <p className='my-2'>We retain personal information only as long as necessary to fulfill the purposes outlined in this Privacy Policy or as required by law. Users may request deletion of their information by contacting us.

            </p>
       
            <h2 className="text-xl font-bold text-black mt-8"> 9. Changes to This Privacy Policy</h2>
            <p className='my-2'>We may update this Privacy Policy periodically. Users will be notified of any significant changes via email or through an in-app notification. Continued use of our services after any update constitutes acceptance of the revised policy.
            </p>
        


















            <h2 className="text-xl font-bold text-black mt-8">10. Contact Us</h2>
            <p className="mt-4 text-gray-700 leading-relaxed">
                If you have any questions or concerns about this Privacy Policy, or if you would like to access, correct, or delete your personal information, please contact us:
            </p>
            <p className="text-gray-700">
                <strong>XReality Education Limited</strong><br />
                Email: <a href="mailto:info@xrealityedu.com" className="text-primary hover:underline">info@xrealityedu.com</a>
            </p>

            <p className="mt-8 text-gray-600">
                By using XReality Education, users agree to the terms of this Privacy Policy. We are committed to safeguarding your privacy and protecting your personal information.
            </p>
        </div>
    );
};

export default PrivacyPolicy;